<template>
    <ul class="list-inline" id="cookie-consent-footer-nav">
        <li><a href="/agb">AGB</a></li>
        <li><a href="/impressum">Impressum</a></li>
    </ul>
</template>

<script setup>
// CookieConsentFooterNav - Simple footer navigation for cookie consent dialog
</script>

<style scoped>
    #cookie-consent-footer-nav {
        position: fixed;
        z-index: 100001;
        left: 20px;
        bottom: 10px;
    }

    #cookie-consent-footer-nav li a {
        color: #ffffff78;
    }
</style>